
import { MapLocation } from '@/types/location';

// Super Touch Center Locations
export const superTouchCenters: MapLocation[] = [
  {
    id: 55001,
    name: "Super Touch - Riyadh (Al Khaleej)",
    type: "Game Center",
    devices: 5,
    coordinates: [24.76342228247746, 46.8001830220883],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Unisex",
    ageRange: "16-45",
    orientation: "Portrait",
    segment: "Game"
  }
];
